import clsx from 'clsx'
import isEmpty from 'lodash/isEmpty'
import React, { useState } from 'react'

import SvgAngleRight from '@Assets/SVG/AngleRight'
import { BuyButtonV2 } from '@Components/BuyButton/v2'
import { BuyQuantityProducts } from '@Domains/Product/Features/Display/Info/Info'
import { Product } from '@Generated/graphql'
import { useTranslation } from '@Globals/Translations'

import styles from './BuyButtonArea.module.scss'

export const BuyButtonArea = ({
  buyPersonalizationID,
  buyQuantitySelection,
  className,
  product,
  selectedCrossSellIDs,
  selectedVariantID,
  variantsInTotal,
}: {
  buyPersonalizationID?: string | null
  buyQuantitySelection: BuyQuantityProducts
  className?: string
  product: Product
  selectedCrossSellIDs: string[]
  selectedVariantID: string
  variantsInTotal: number
}) => {
  const { t } = useTranslation()
  const [promptsOpen, setPromptsOpen] = useState(false)

  return (
    <div className={clsx(!promptsOpen && styles.stickyBox, className)}>
      <div className={styles.box}>
        <BuyButtonV2
          className={clsx(styles.buyButton)}
          color="black"
          onPromptChange={setPromptsOpen}
          productID={product.id}
          products={[
            {
              productID: product.id,
              quantity: buyQuantitySelection.quantity,
              variantID: selectedVariantID,
            },
            ...(buyPersonalizationID
              ? [
                {
                  productID: buyPersonalizationID,
                  parentIndex: 0,
                },
              ]
              : []),
            ...(isEmpty(selectedCrossSellIDs)
              ? []
              : selectedCrossSellIDs.map(productID => ({
                productID,
                quantity: 1,
              }))),
          ]}
          quantity={buyQuantitySelection.quantity}
          variantID={selectedVariantID}
        >
          {variantsInTotal > 1
            ? (
              <>
                {t('products:CHOOSE_SIZE')}
                <SvgAngleRight className={styles.icon} />
              </>
            )
            : t('cms:ADD_TO_CART')}
        </BuyButtonV2>
      </div>
    </div>
  )
}
